<template>
  <div style="height: 100%; position: relative">
    <el-card
      shadow="never"
      class="box-card"
      style="height: 100%"
      :body-style="{ padding: '0px' }"
    >
      <template #header>
        <div class="clearfix">
          {{ titlename }}
        </div>
      </template>
      <el-radio-group
        v-show="showflag"
        v-model="iosorandroid"
        style="
          position: absolute;
          z-index: 10;
          margin-left: 19px;
          margin-top: 10px;
        "
        size="small"
      >
        <el-radio-button label="all">全部渠道</el-radio-button>
        <el-radio-button label="ios">iPhone</el-radio-button>
        <el-radio-button label="android">安卓</el-radio-button>
      </el-radio-group>
      <div
        :id="chartid"
        v-bind:style="{ width: '100%', height: heightnum + 'px' }"
      ></div>
    </el-card>
  </div>
</template>

<script setup>
import { defineProps, onMounted, onBeforeUnmount, ref, watch } from "vue";
import * as echarts from "echarts";

const props = defineProps({
  titlename: {
    type: String,
  },
  chartid: {
    type: String,
  },
  piedata: {
    type: Object,
  },
  wzbj: {
    type: String,
  },
  heightnum: {
    type: Number,
    default: 350,
  },
  pieradius: {
    type: Array,
    default: function () {
      return ["45%", "60%"];
    },
  },
});

let pieChart = null;
const pieoption = {
  title: [
    {
      text: "下载总量",
      left: "27%",
      top: "38%",
      textAlign: "center",
      textBaseline: "middle",
      textStyle: {
        color: "#999",
        fontWeight: "normal",
        fontSize: 20,
      },
    },
    {
      text: "",
      left: "28%",
      top: "48%",
      textAlign: "center",
      textBaseline: "middle",
      textStyle: {
        color: "#666",
        fontWeight: "normal",
        fontSize: 26,
      },
    },
  ],
  color: [
    "#EED610",
    "#39A9D9",
    "#FFB210",
    "#7EC651",
    "#4EA11B",
    "#FBAE94",
    "#C7B5DB",
    "#975FE4",
    "#36CBCB",
    "#F2637B",
  ],
  tooltip: {
    show: false,
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
  legend: {
    type: "scroll",
    orient: "vertical",
    align: "left",
    right: 10,
    top: "middle",
    data: ["无数据"],
  },
  series: [
    {
      name: "下载总量",
      type: "pie",
      center: ["28%", "45%"],
      radius: [],
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center",
        },
        emphasis: {
          show: false,
          textStyle: {
            fontSize: "30",
            fontWeight: "bold",
          },
        },
      },
      labelLine: {
        normal: {
          show: false,
        },
      },
      data: [{ value: 0, name: "无数据" }],
    },
  ],
};

const showflag = ref(false);
const iosorandroid = ref("all");
onMounted(() => {
  if (props.wzbj == "pieleft") {
    iosorandroid.value = "all";
    showflag.value = false;
  } else {
    showflag.value = true;
  }
  if (pieChart === null) {
    pieChart = echarts.init(document.getElementById(props.chartid));
    window.onresize = pieChart.resize;
  }
  pieoption.series[0].radius = props.pieradius;
});

onBeforeUnmount(() => {
  if (pieChart) {
    pieChart.dispose();
    pieChart = null;
    window.onresize = undefined;
  }
});

watch([() => props.piedata, iosorandroid], () => {
  makePieChart();
});

let alldatanum = 0;
function makePieChart() {
  const data = props.piedata;
  const legendData = [];
  const seriesData = [];
  let allNum = 0;
  if (props.wzbj == "pieleft") {
    //统计合并的数量
    let iphoneNum = 0;
    let androidNum = 0;
    let iphoneData = data.iOS;
    let androidData = data.android;
    if (iphoneData instanceof Array) {
      console.log("统计合并的数量: ", iphoneData, androidData);

      for (let i = 0; i < iphoneData.length; i++) {
        for (const key in iphoneData[i]) {
          allNum = allNum + iphoneData[i][key];
          iphoneNum = iphoneNum + iphoneData[i][key];
        }
      }

      for (let i = 0; i < androidData.length; i++) {
        for (const key in androidData[i]) {
          allNum = allNum + androidData[i][key];
          androidNum = androidNum + androidData[i][key];
        }
      }
    } else {
      iphoneNum = iphoneData;
      androidNum = androidData;
      allNum = iphoneNum + androidNum;
    }
    const iphoneName = "iPhone," + iphoneNum;
    const androidName = "安卓," + androidNum;
    legendData.push(iphoneName);
    legendData.push(androidName);
    seriesData.push({ name: iphoneName, value: iphoneNum });
    seriesData.push({ name: androidName, value: androidNum });
  } else {
    //分机型统计
    const iphoneData = data.iOS;
    const androidData = data.android;
    if (iosorandroid.value == "ios" || iosorandroid.value == "all") {
      for (let i = 0; i < iphoneData.length; i++) {
        for (const key in iphoneData[i]) {
          allNum = allNum + iphoneData[i][key];
          legendData.push(key + "," + iphoneData[i][key]);
          seriesData.push({
            name: key + "," + iphoneData[i][key],
            value: iphoneData[i][key],
          });
        }
      }
    }
    if (iosorandroid.value == "android" || iosorandroid.value == "all") {
      for (let i = 0; i < androidData.length; i++) {
        for (const key in androidData[i]) {
          allNum = allNum + androidData[i][key];
          legendData.push(key + "," + androidData[i][key]);
          seriesData.push({
            name: key + "," + androidData[i][key],
            value: androidData[i][key],
          });
        }
      }
    }
  }
  alldatanum = allNum;
  const option = JSON.parse(JSON.stringify(pieoption));
  if (data.iOS.length == 0 && data.android.length == 0) {
    pieChart.setOption(pieoption);
  } else {
    option.legend.formatter = legendformatter;
    option.title[1].text = toThousands(allNum);
    option.legend.data = legendData;
    option.series[0].data = seriesData;
    pieChart.setOption(option);
  }
}

function toThousands(num) {
  //千分位格式化
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
function legendformatter(name) {
  let legendlabelarr = name.split(",");
  let bfb;
  if (this.alldatanum == 0) {
    bfb = "--";
  } else {
    bfb = ((Number(legendlabelarr[1]) / this.alldatanum) * 100).toFixed(2);
  }
  return legendlabelarr[0] + "    " + legendlabelarr[1] + "     " + bfb + "%";
}
</script>

<style scoped>
.box-card {
  width: 100%;
  height: 100%;
}
</style>
